export function ImageView({ src, alt }: { src: string; alt?: string }) {
  return (
    <div className="flex justify-center rounded-md bg-muted/30 p-3">
      <img src={src} alt={alt ?? ''} className="max-w-full rounded" />
    </div>
  );
}
